import React from 'react';
import propTypes from "prop-types";
import { Segment, Header, Form, Button, Message } from 'semantic-ui-react';
import SummaryField from "../common/SummaryField";
import { dateTimeToString } from "../../frameworks/Util";
import { URL_POND } from '../../constances';
import ConfirmModal from '../common/ConfirmModal';
import { POST } from '../../frameworks/HttpClient';

export default function CleanSegment(props) {
	const [openModal, setOpenModal] = React.useState(false)
	const [loading, setLoading] = React.useState(false)
	const [errorMessages, setErrorMessages] = React.useState(null)

	/** Back to PRODUCE state */
	const handleChangeState = async () => {
		setLoading(true);
		try {
			await POST(`${URL_POND.POND_TRANSACTION}${props.data ? props.data.id : ""}/reverse_to_produce/`)
			setOpenModal(false);
			props.onReload();
		} catch (e) {
			setErrorMessages(e.errorMessages);
		} finally {
			setLoading(false);
		}
	}

	React.useEffect(() => {
		if (openModal && errorMessages)
			setErrorMessages(null)
	}, [openModal])

	return (
		<Segment style={{width: "55%", margin: "auto", ...props.style}}>
			<Header dividing>ทำความสะอาด</Header>

			<Form style={{textAlign: "center"}}>
				<SummaryField 
					title={"เริ่มทำความสะอาด"}
					value={(props.data && props.data.clean_date) 
						? dateTimeToString(props.data.clean_date)
						: "-"} />
			</Form>
			<div style={{textAlign: "right", marginTop: 16}}>
				{/* <Button primary 
					icon={"undo"} 
					content={"ย้อนสถานะ [เปิดบ่อ]"} 
					disabled={!(props.data && (props.data.weight > 0))}
					onClick={() => setOpenModal(true)}/> */}
			</div>

			<ConfirmModal
				open={openModal}
				title={"ย้อนสถานะ [เปิดบ่อ]"}
				detail={
					<div>
						{errorMessages && (
							<Message 
								negative
								header={"เกิดข้อผิดพลาด"}
								content={errorMessages}/>
						)}
						<p>{`คุณต้องการแก้ไขสถานะจาก "ทำความสะอาด" เป็น "เปิดบ่อพักน้ำยาง" ใช่หรือไม่ ?`}</p>
					</div>
				}
				loading={loading}
				onClose={() => setOpenModal(false)}
				onCancel={() => setOpenModal(false)}
				onConfirm={handleChangeState}/>
		</Segment>
	)
}

CleanSegment.defaultProps = {
	style: null,
	data: null,
	onReload: () => {},
}

CleanSegment.propTypes = {
	data: propTypes.object,
	onReload: propTypes.func
}